import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import BulbIcon from "@/assets/icons/infrastructure-architecture/bulb_icon.svg";

export const InfrastructureArchitectureRecommendationPanelNoData: FC = () => {
  return (
    <Stack
      mx={2}
      py={1.5}
      px={3}
      border={1}
      spacing={3}
      direction="row"
      borderRadius={2}
      alignItems="center"
      justifyContent="center"
      borderColor="primary.main"
    >
      <img src={BulbIcon} alt="bulb" />

      <Typography variant="subtitle2" fontWeight="normal">
        No recommendations found for the selected architecture.
      </Typography>
    </Stack>
  );
};
